import { AudienceTypesDataProps } from "components/public-site/audience-sort/utility/audienceSortPropTypes";
import ky from "ky-universal";

type SuccessStatus = "success";
type FailedStatus = "failed";

type Status = SuccessStatus | FailedStatus | number;
type AudienceFromLinkAPIData = {
	apiUrl: string;
	action: string;
	status: Status;
} & Error &
	AudienceTypesDataProps;

const getAudienceTypesForCountryData = async (audienceType) => {
	let apiUrl, countryKey;
	if (audienceType.isPage) {
		const audienceTypeData: { apiUrl: string; countryKey: string } =
			window[audienceType.source as string];

		apiUrl = audienceTypeData.apiUrl;
		countryKey = audienceTypeData.countryKey;
	} else {
		apiUrl = audienceType.apiUrl;
		countryKey = audienceType.country.countryKey;
	}

	if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
		apiUrl = "http://localhost:7000/audience-selector-api/get-audience-types-for-country";
	}

	const data: { status: Status; data?: string | AudienceFromLinkAPIData; error?: Error } = await ky
		.post(apiUrl, {
			headers: new Headers({
				"Content-Type": "application/json"
			}),
			body: JSON.stringify({
				countryKey: countryKey
			})
		})
		.then<{ status: Status; data?: string | AudienceFromLinkAPIData }>((response) => {
			if (response.status === 200) {
				return response.json<AudienceFromLinkAPIData>().then((data) => {
					if (Object.hasOwn(data, "status")) {
						if (data.status === "failed") {
							console.error(data);
							return {
								status: data.status,
								data: data
							};
						}
						if (data.action === "reload") {
							return {
								status: data.status,
								data: data.action
							};
						}
						return {
							status: "success",
							data: data
						};
					}
					return {
						status: "success",
						data: data
					};
				});
			} else {
				return {
					status: "failed",
					error: `${response.status}`
				};
			}
		})
		.then((res) => res)
		.catch((error) => {
			console.error(error);
			return {
				status: "failed",
				error: error
			};
		});
	return data;
};

export default getAudienceTypesForCountryData;
